import { render } from "./portrait.vue?vue&type=template&id=3cf0c097&scoped=true"
import script from "./portrait.vue?vue&type=script&lang=js"
export * from "./portrait.vue?vue&type=script&lang=js"

import "./portrait.vue?vue&type=style&index=0&id=3cf0c097&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf0c097"]])

export default __exports__